import React from 'react';
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
          <p><strong>{label}</strong></p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color, whiteSpace: "normal" }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
};


const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={5} // Adjust vertical alignment
                textAnchor="end" // Align the text properly
                transform="rotate(270)" // Rotate the text by 90 degrees
                fill="#616161"
                style={{ fontSize: "14px" }}
            >
                {payload.value}
            </text>
        </g>
    );
};


function getRoundingBase(value) {
  const absValue = Math.abs(value);
  if (absValue < 1) return 0.1;
  if (absValue < 10) return 1;
  if (absValue < 100) return 5;
  if (absValue < 1000) return 10;
  return 100;
}

function roundUpToNearest(value, base) {
  return Math.ceil(value / base) * base;
}


function generateSymmetricTicksAndDomain(maxValue, tickCount = 9) {
  const intervalCount = tickCount - 1;
  const step = roundUpToNearest((2 * maxValue) / intervalCount, getRoundingBase(maxValue));
  const domainMax = step * Math.floor(intervalCount / 2);
  const domainMin = -domainMax;
  const ticks = [];
  if(step !== 0){
    for (let i = domainMin; i <= domainMax; i += step) {
      // ticks.push(i);
      ticks.push(Number(i.toFixed(2)));
    }
  }
  return { ticks, domainMin, domainMax };
}


function generatePositiveIntegerTicksAndDomain(maxValue, tickCount = 5) {
  const domainMax = Math.ceil(maxValue); // round up to integer
  const intervalCount = tickCount - 1;
  const step = Math.ceil(domainMax / intervalCount); // integer step
  const adjustedDomainMax = step * intervalCount; // ensure max is multiple of step
  const domainMin = 0;
  const ticks = [];
  if(step !== 0){
    for (let i = domainMin; i <= adjustedDomainMax; i += step) {
      // ticks.push(i);
      ticks.push(Number(i.toFixed(2)));
    }
  }
  return { ticks, domainMin, domainMax: adjustedDomainMax };
}

function findMinMax(data, dataKey) {
  let values = [];
  
  data?.forEach(item => {
      Object.keys(item).forEach(key => {
          if (key !== dataKey && item[key] !== null) {
              const num = parseFloat(item[key]);
              if (!isNaN(num)) {
                  values.push(num);
              }
          }
      });
  });
  
  return {
      min: Math.min(...values),
      max: Math.max(...values)
  };
}


const CustomTooltipPowerSteering = ( active, payload, label, nameKey, actualKey, plannedKey, forecastKey ) => {
	if (active && payload && payload.length) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
				<div >{`${payload[0]['payload'][nameKey]}`}</div>
				{payload[0]['payload'][actualKey] && 
                    <div style={{ color: "#0078A7" }}>Actual: {`${payload[0]['payload'][actualKey]}`}</div> }
				{payload[0]['payload'][plannedKey] && 
                    <div style={{ color: "#B05788" }}>Plan: {`${payload[0]['payload'][plannedKey]}`}</div> }
				{payload[0]['payload'][forecastKey] && 
                    <div style={{ color: "#FF891C" }}>Forecast: {`${payload[0]['payload'][forecastKey]}`}</div>}
			</div>
		);
	}

	return null;
};


export { CustomTooltip, CustomizedTick, generateSymmetricTicksAndDomain, generatePositiveIntegerTicksAndDomain, findMinMax, CustomTooltipPowerSteering }
